import Call from '../Call';
import {objToQs} from '../Utils';

const BidderNetworkPerfromance = {
    get(filters) {
        return Call(`bidderNetworkPerformance?${objToQs(filters)}`);
    },

    getAffids() {
        return Call(`bidderNetworkPerformance/affid`);
    },

    get2(filters, path = '') {
        return Call(`bidderNetworkPerformance2/${path}?${objToQs(filters)}`);
    },

    get3(filters, path = '') {
        return Call(`bidderNetworkPerformance3/${path}?${objToQs(filters)}`);
    },

    getHourly(filters, path = '') {
        return Call(`bidderNetworkPerformanceHourly/${path}?${objToQs(filters)}`);
    },
};

export default BidderNetworkPerfromance;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderNetworkPerformance.js